export const USER_CONSTANT = {
    // テーブル名
    TABLE: 'delivery',
    CSV_FILENAME: '配送・集荷先一覧'
  };
  